<div id="wrapper-container" class="container-fluid">

  <a id="logo" href="/"></a>

  <div id="content-box" class="container-fluid container-lg">

    <div class="row justify-content-center">
      <div id="content-box-content" class="col-12 col-md-8 col-lg-6 text-center">
        <h3 class="mb-4">Log in to Idio CRM</h3>

        <form [formGroup]="form" (ngSubmit)="submit()" class="text-start" novalidate>
          <div class="mb-3">
            <label for="email" class="form-label">Email</label>
            <input
              id="email"
              type="email"
              class="form-control"
              formControlName="email"
              autocomplete="username"
              [class.is-invalid]="form.controls.email.touched && form.controls.email.invalid"
            >
            @if (form.controls.email.touched && form.controls.email.invalid) {
              <div class="invalid-feedback">Enter a valid email address.</div>
            }
          </div>

          <div class="mb-3">
            <label for="password" class="form-label">Password</label>
            <input
              id="password"
              type="password"
              class="form-control"
              formControlName="password"
              autocomplete="current-password"
              [class.is-invalid]="form.controls.password.touched && form.controls.password.invalid"
            >
            @if (form.controls.password.touched && form.controls.password.invalid) {
              <div class="invalid-feedback">Password is required.</div>
            }
          </div>

          <button type="submit" class="btn btn-primary w-100" [disabled]="submitting()">
            @if (submitting()) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            }
            Log in
          </button>
        </form>

        @if (errorMessage()) {
          <div class="alert alert-danger mt-3" role="alert">
            {{ errorMessage() }}
          </div>
        }
      </div>
    </div>

  </div>

</div>
